import { render } from "./PreOrderPriceBox.vue?vue&type=template&id=43bdc30c&scoped=true&ts=true"
import script from "./PreOrderPriceBox.vue?vue&type=script&lang=ts"
export * from "./PreOrderPriceBox.vue?vue&type=script&lang=ts"

import "./PreOrderPriceBox.vue?vue&type=style&index=0&id=43bdc30c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bdc30c"]])

export default __exports__